/**
 * Arabic for the certification register on the platform (build 2): the shell's
 * notices when a certificate is saved, and the board's own text — the panel,
 * the add form, the register's state line — which i18n/dom.ts translates
 * inside the boards and the shared sheet. Proposed; pending native review.
 *
 * "Issue" here is one issue of a certificate (إصدار), never a problem; "in
 * force" is نافذ.
 */
const ar: Record<string, string> = {
  /* the shell's notices (demo/platform/writes/certificates.ts) */
  "Certificate {ref} saved on the platform and in force.": "حُفظت الشهادة {ref} على المنصة وأصبحت نافذة.",
  "Renewal {ref} saved on the platform and in force.": "حُفظ التجديد {ref} على المنصة وأصبح نافذًا.",
  "{ref} saved on the platform. This kind of certificate is reviewed before it goes in force.":
    "حُفظ {ref} على المنصة. هذا النوع من الشهادات يُراجَع قبل أن يصبح نافذًا.",
  "{ref} saved on the platform. It goes in force when someone who can approve documents issues it.":
    "حُفظ {ref} على المنصة. يصبح نافذًا عندما يُصدره شخص مخوّل باعتماد الوثائق.",
  "There is no recorded issue waiting to go in force.": "لا يوجد إصدار مسجّل بانتظار أن يصبح نافذًا.",
  "Certificate issue {ref} is now in force.": "إصدار الشهادة {ref} نافذ الآن.",
  "Choose the issue and the file to attach.": "اختر الإصدار والملف المراد إرفاقه.",
  "{name} filed with {ref} on the platform.": "حُفظ {name} مع {ref} على المنصة.",
  "{ref} raised in the work order register for this certificate.": "فُتح {ref} في سجل أوامر العمل لهذه الشهادة.",

  /* the panel */
  "Saving to the library…": "جارٍ الحفظ في المكتبة…",
  "Not saved in the library": "لم يُحفظ في المكتبة",
  "Saved in the library": "حُفظ في المكتبة",
  "Waiting to go in force": "بانتظار أن يصبح نافذًا",
  "Issues of this certificate": "إصدارات هذه الشهادة",
  "Reading the certificate's history…": "جارٍ قراءة سجل الشهادة…",
  "Someone who can approve documents puts it in force.": "يجعله نافذًا شخص مخوّل باعتماد الوثائق.",
  "Record an issue": "سجّل إصدارًا",
  "Record a renewal": "سجّل تجديدًا",
  "No issue recorded yet.": "لم يُسجَّل أي إصدار بعد.",
  "In force since": "نافذ منذ",
  "no issue recorded: record one with its dates": "لا يوجد إصدار مسجّل: سجّل إصدارًا بتواريخه",
  "a recorded issue is waiting to go in force": "إصدار مسجّل بانتظار أن يصبح نافذًا",
  "no certificate document on file": "لا توجد وثيقة شهادة محفوظة",
  "The file can be added once the certificate is saved on the platform.":
    "يمكن إضافة الملف بعد حفظ الشهادة على المنصة.",
  "Record an issue first. The file goes with an issue.": "سجّل إصدارًا أولًا. الملف يُرفق بالإصدار.",
  "This issue already has its file. To file a new certificate, record a renewal.":
    "لهذا الإصدار ملفه بالفعل. لحفظ شهادة جديدة، سجّل تجديدًا.",
  "Your role cannot add documents (document:write).": "دورك لا يسمح بإضافة وثائق (document:write).",
  "Your role cannot raise work orders (work_order:write).": "دورك لا يسمح بفتح أوامر عمل (work_order:write).",
  "+ File the certificate": "+ احفظ الشهادة",
  "+ File the certificate or its evidence": "+ احفظ الشهادة أو أدلتها",
  "the certificate in force": "الشهادة النافذة",
  "The certificate file cannot be opened here.": "لا يمكن فتح ملف الشهادة هنا.",
  "Raise work to clear it": "افتح عملًا لمعالجتها",
  "New reference": "المرجع الجديد",

  /* the add form */
  "Add a certificate": "أضف شهادة",
  "+ Add a certificate": "+ أضف شهادة",
  Certificate: "الشهادة",
  "Issued by": "صادرة عن",
  "Accountable post": "المنصب المسؤول",
  "Maintenance behind it": "الصيانة التي تستند إليها",
  "Evidence expected": "الأدلة المتوقعة",
  "Anything noted on it": "أي ملاحظة مدوّنة عليها",
  "The certificate": "الشهادة نفسها",
  "It is saved in the platform's library, where colleagues see it.": "تُحفظ في مكتبة المنصة حيث يراها الزملاء.",
  "In the demo it is kept in this browser.": "في العرض التوضيحي تُحفظ في هذا المتصفح.",
  "What the certificate is for": "ما الذي تخصه الشهادة",
  "Optional, as in the asset register": "اختياري، كما في سجل الأصول",
  "As it is titled": "كما هو عنوانها",
  "As it appears on the certificate": "كما يظهر على الشهادة",
  "A post, not a person": "منصب، لا شخص",
  "One item of evidence per line": "دليل واحد في كل سطر",
  "Name the asset the certificate is for.": "اذكر الأصل الذي تخصه الشهادة.",
  "Give the certificate its title.": "اكتب عنوان الشهادة.",
  "An expiry date is the whole point of the record.": "تاريخ الانتهاء هو جوهر السجل.",
  "It cannot expire before it was issued.": "لا يمكن أن تنتهي قبل تاريخ إصدارها.",
  "Friction survey": "مسح الاحتكاك",

  /* the register's state line */
  "Reading the certificate register…": "جارٍ قراءة سجل الشهادات…",
  "No certificates on the record yet. Add the first with + ADD A CERTIFICATE.":
    "لا توجد شهادات في السجل بعد. أضف أولها عبر + أضف شهادة.",
};

export default ar;
